import * as tslib_1 from "tslib";
/* I26 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var Link = /** @class */ (function (_super) {
    tslib_1.__extends(Link, _super);
    function Link() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Link.prototype.render = function () {
        return (React.createElement(IconWrap, tslib_1.__assign({}, this.props),
            React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
                React.createElement("g", null,
                    React.createElement("path", { d: "M18.894 5.106a3.786 3.786 0 0 0-5.349 0l-1.652 1.652a.864.864 0 0 0 0 1.22.864.864 0 0 0 1.22 0l1.651-1.653a2.062 2.062 0 0 1 2.911 0 2.062 2.062 0 0 1 0 2.911l-3.329 3.328a2.059 2.059 0 0 1-2.91 0 .863.863 0 0 0-1.22 1.22 3.774 3.774 0 0 0 2.675 1.106c.968 0 1.937-.369 2.674-1.106l3.329-3.329a3.788 3.788 0 0 0 0-5.349m-8.005 10.916l-1.652 1.652a2.06 2.06 0 0 1-2.91 0 2.06 2.06 0 0 1 0-2.91l3.329-3.329a2.06 2.06 0 0 1 2.91 0 .861.861 0 1 0 1.219-1.22 3.787 3.787 0 0 0-5.349 0l-3.328 3.33A3.758 3.758 0 0 0 4 16.218c0 1.01.393 1.96 1.108 2.675A3.77 3.77 0 0 0 7.782 20c.968 0 1.937-.369 2.674-1.106l1.652-1.653a.861.861 0 1 0-1.219-1.219" })))));
    };
    return Link;
}(React.Component));
export { Link };
export default Link;
//# sourceMappingURL=Link.js.map